/**
 * FloatingButtons Component
 * 
 * Toggle buttons untuk buka/tutup floating panels
 * Posisi: Top Left
 */

import React from 'react'

export default function FloatingButtons({
  viewportReady,
  showPanel,
  // Panel states
  isExportPanelOpen,
  setIsExportPanelOpen,
  isLightsPanelOpen,
  setIsLightsPanelOpen,
  isMaterialPanelOpen,
  setIsMaterialPanelOpen,
  isCameraPanelOpen,
  setIsCameraPanelOpen,
  // Features
  showLightsPanel = true,
  showCameraPanel = true,
  cameras = [],
  selectedCamera,
  setSelectedCamera,
  selectedCameraRef,
}) {
  if (!viewportReady || !showPanel) return null

  return (
    <div
      style={{
        position: 'absolute',
        top: '20px',
        left: '20px',
        zIndex: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        animation: 'slideInFromLeft 0.5s cubic-bezier(0.32, 0.72, 0, 1) forwards',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
      }}
    >
      {/* Export Panel Toggle */}
      <button
        onClick={() => {
          setIsExportPanelOpen(!isExportPanelOpen)
          // Auto-hide other left panels
          if (!isExportPanelOpen) {
            setIsLightsPanelOpen(false)
          }
        }}
        style={{
          padding: '12px',
          background: isExportPanelOpen
            ? 'linear-gradient(135deg, rgba(16, 185, 129, 0.82), rgba(5, 150, 105, 0.88))'
            : 'linear-gradient(135deg, rgba(59, 130, 246, 0.82), rgba(37, 99, 235, 0.88))',
          backdropFilter: 'blur(20px) saturate(190%)',
          WebkitBackdropFilter: 'blur(20px) saturate(190%)',
          color: '#fff',
          border: '0.5px solid rgba(255, 255, 255, 0.22)',
          borderTop: '0.5px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '12px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 600,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.18), 0 8px 24px rgba(0, 0, 0, 0.12)',
          transition: 'all 0.32s cubic-bezier(0.32, 0.72, 0, 1)',
          minWidth: '48px',
          fontFamily: 'system-ui, -apple-system, sans-serif',
        }}
        title="Export & Resolution"
      >
        📐
      </button>

      {/* Lights Panel Toggle */}
      {showLightsPanel && (
        <button
          onClick={() => {
            setIsLightsPanelOpen(!isLightsPanelOpen)
            // Auto-hide other left panels
            if (!isLightsPanelOpen) {
              setIsExportPanelOpen(false)
            }
          }}
          style={{
            padding: '12px',
            background: isLightsPanelOpen
              ? 'linear-gradient(135deg, rgba(16, 185, 129, 0.82), rgba(5, 150, 105, 0.88))'
              : 'linear-gradient(135deg, rgba(59, 130, 246, 0.82), rgba(37, 99, 235, 0.88))',
            backdropFilter: 'blur(20px) saturate(190%)',
            WebkitBackdropFilter: 'blur(20px) saturate(190%)',
            color: '#fff',
            border: '0.5px solid rgba(255, 255, 255, 0.22)',
            borderTop: '0.5px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '12px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 600,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.18), 0 8px 24px rgba(0, 0, 0, 0.12)',
            transition: 'all 0.32s cubic-bezier(0.32, 0.72, 0, 1)',
            minWidth: '48px',
            fontFamily: 'system-ui, -apple-system, sans-serif',
          }}
          title="Custom Lights"
        >
          💡
        </button>
      )}

      {/* Material Panel Toggle */}
      <button
        onClick={() => {
          setIsMaterialPanelOpen(!isMaterialPanelOpen)
        }}
        style={{
          padding: '12px',
          background: isMaterialPanelOpen
            ? 'linear-gradient(135deg, rgba(16, 185, 129, 0.82), rgba(5, 150, 105, 0.88))'
            : 'linear-gradient(135deg, rgba(59, 130, 246, 0.82), rgba(37, 99, 235, 0.88))',
          backdropFilter: 'blur(20px) saturate(190%)',
          WebkitBackdropFilter: 'blur(20px) saturate(190%)',
          color: '#fff',
          border: '0.5px solid rgba(255, 255, 255, 0.22)',
          borderTop: '0.5px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '12px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 600,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.18), 0 8px 24px rgba(0, 0, 0, 0.12)',
          transition: 'all 0.32s cubic-bezier(0.32, 0.72, 0, 1)',
          minWidth: '48px',
          fontFamily: 'system-ui, -apple-system, sans-serif',
        }}
        title="Material Editor"
      >
        🎨
      </button>

      {/* Camera Panel Toggle Button */}
      {showCameraPanel && cameras.length > 0 && (
        <button
          onClick={() => {
            setIsCameraPanelOpen(!isCameraPanelOpen)
            // Auto-hide other left panels
            if (!isCameraPanelOpen) {
              setIsExportPanelOpen(false)
              setIsLightsPanelOpen(false)
            }
          }}
          style={{
            padding: '12px',
            background: isCameraPanelOpen
              ? 'linear-gradient(135deg, rgba(16, 185, 129, 0.82), rgba(5, 150, 105, 0.88))'
              : 'linear-gradient(135deg, rgba(59, 130, 246, 0.82), rgba(37, 99, 235, 0.88))',
            backdropFilter: 'blur(20px) saturate(190%)',
            WebkitBackdropFilter: 'blur(20px) saturate(190%)',
            color: '#fff',
            border: '0.5px solid rgba(255, 255, 255, 0.22)',
            borderTop: '0.5px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '12px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 600,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.18), 0 8px 24px rgba(0, 0, 0, 0.12)',
            transition: 'all 0.32s cubic-bezier(0.32, 0.72, 0, 1)',
            minWidth: '48px',
            fontFamily: 'system-ui, -apple-system, sans-serif',
          }}
          title="Camera Selector"
        >
          🎥
        </button>
      )}
    </div>
  )
}

